
/**
 * 강의 난이도
 */
export type CourseDetailSummaryPropertyLevel = typeof CourseDetailSummaryPropertyLevel[keyof typeof CourseDetailSummaryPropertyLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDetailSummaryPropertyLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
